// @flow

import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

class CellStatusFilter extends React.Component {
  render() {
    const { padding, name, value, onChange, i18n } = this.props;

    return (
      <TableCell padding={padding}>
        <Select
          fullWidth
          displayEmpty
          onChange={onChange}
          name={name}
          value={value || ''}
        >
          <MenuItem value="">{i18n('All')}</MenuItem>
          <MenuItem value="DRAFT">{i18n('Draft')}</MenuItem>
          <MenuItem value="PENDING_REVIEW">{i18n('Pending')}</MenuItem>
          <MenuItem value="DOCUMENTATION_REQUESTED">
            {i18n('Requested')}
          </MenuItem>
          <MenuItem value="APPROVED">{i18n('Approved')}</MenuItem>
          <MenuItem value="REJECTED">{i18n('Rejected')}</MenuItem>
          <MenuItem value="DEACTIVATED">{i18n('Deactivated')}</MenuItem>
        </Select>
      </TableCell>
    );
  }
}

export default CellStatusFilter;